<template>
    <div>
        <h1 class="title has-text-centered">
            {{ title }}
        </h1>
        <h2 class="subtitle has-text-centered">
            {{ subtitle }}
        </h2>
    </div>
</template>

<script>
    export default {
        name: "PageTitle",
        props: ['title', 'subtitle']
    }
</script>